// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1Kyln","legacyBtn":"MutateMid_legacyBtn__333hP"};